const FullBleed = () => (
  <section className="relative py-28 px-6 border-b border-white/10 overflow-hidden" data-testid="urgent-band">
    <img
      src="https://images.pexels.com/photos/32026177/pexels-photo-32026177.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
      alt="Panoramic illuminated tech command center with ultra-wide screens"
      loading="lazy"
      className="absolute inset-0 w-full h-full object-cover drift-frame"
    />
    <div className="absolute inset-0 bg-gradient-to-b from-[#110e1a] via-[#4c1d95]/70 to-[#110e1a]" />
    <div className="relative max-w-4xl mx-auto text-center">
      <span className="text-xs font-mono uppercase tracking-widest text-pink-300">24 Hours / 7 Days A Week</span>
      <h2 className="font-poster text-4xl sm:text-6xl uppercase tracking-wide text-white mt-3 mb-6">
        Never Miss An Urgent Deadline
      </h2>
      <p className="text-slate-200 text-sm max-w-lg mx-auto leading-relaxed mb-8">
        Direct engineering and scholarly help available day and night.
      </p>
      <a
        href="#contact"
        data-testid="urgent-band-cta"
        className="inline-block px-8 py-4 rounded-xl bg-white text-slate-950 font-bold text-xs font-mono uppercase tracking-wider hover:bg-slate-200 transition-colors shadow-2xl"
      >
        Get Instant Help Now
      </a>
    </div>
  </section>
);

export default FullBleed;
